import {API_URL, API_URL_STORY} from '../constants'
import { apiFetch } from './client';
import {setNotifications} from "../store/slices/notifications";


export const stringifyTagsParameters = (parameters) => {
    const query = [];
    try {
        Object.keys(parameters)
            .filter((key) => parameters[key])
            .forEach((key) => {
                switch (key) {
                    case 'page':
                    case 'statusId':
                    case 'occasionId':
                    case 'recipientId':
                    case 'authorId':
                    case 'productId':
                    case 'isPublished': {
                        // @ts-ignore
                        query.push(`${key}=${parameters[key]}`);
                        break;
                    }
                    case 'perPage': {
                        // @ts-ignore
                        query.push(`limit=${parameters[key]}`);
                        break;
                    }
                    case 'tags': {
                        // @ts-ignore
                        query.push(`tagIds=${parameters[key]}`);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });
    } catch (error) {
        console.warn('Looks like something wrong with fetch products url parameters');
    }
    console.log('PARAMS',parameters);
    console.log(query)
    return `${query.join('&')}`;
};

export const getAllStoryTags = async (queryParams) => {
    console.log('queryParams',queryParams);
    const res = await apiFetch(`${API_URL_STORY}/tags?page=${queryParams.page}&limit=${queryParams.perPage}&isDeleted=0`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const createStoryTagCategory = async (data) => {
    const res = await apiFetch(`${API_URL_STORY}/tag-categories`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({...data})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const createStoryTag = async (data: { name: string; categoryId: number }) => {
    const res = await apiFetch(`${API_URL_STORY}/tags`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const updateStoryTagsById = async (id, data) => {
    const res = await apiFetch(`${API_URL_STORY}/stories/${id}/tags`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({...data})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const updateStoryTagCategory = async (id: number, data: { name: string; isDeleted?: 0 | 1 }) => {
    const res = await apiFetch(`${API_URL_STORY}/tag-categories/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const updateStoryTag = async (
    id: number,
    data: { name: string; categoryId: number; isDeleted?: 0 | 1 }
) => {

    const res = await apiFetch(`${API_URL_STORY}/tags/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });

    if (!res.ok) {
        throw new Error('Failed to update tag');
    }

    return await res.json();
};

export const updateCategoryOrder = async (payload: { categories: { id: number; order: number }[] }) => {
    const res = await apiFetch(`${API_URL_STORY}/tag-categories/order`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload)
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getAllTagGroups = async (queryParams: { page?: number; perPage?: number; isDeleted?: 0 | 1 } = {}) => {
    const page = queryParams.page ?? 1;
    const limit = queryParams.perPage ?? 25;
    const isDeleted = queryParams.isDeleted ?? 0;
    const res = await apiFetch(
        `${API_URL_STORY}/tag-groups?page=${page}&limit=${limit}&isDeleted=${isDeleted}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const createTagGroup = async (data: { name: string; tagIds: number[] }) => {
    const res = await apiFetch(`${API_URL_STORY}/tag-groups`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const updateTagGroup = async (
    id: number,
    data: { name: string; isDeleted: 0 | 1; tagIds: number[] }
) => {
    const res = await apiFetch(`${API_URL_STORY}/tag-groups/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    });
    if (!res.ok) {
        if (res.status === 404) {
            throw new Error('Tag group not found');
        }
        throw new Error('Server Error!');
    }
    return await res.json();
};

// export const getAuthorById = async (id) => {
//     const token = store.getState().auth.data.token;
//     const res = await fetch(`${API_URL_STORY}/stories/${id}`,{
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${encodeURIComponent(token)}`
//         },
//     });
//     if (!res.ok) {
//         if(res.status === 401){
//             await logOut();
//             throw new Error('Unauthorized!');
//         }
//         throw new Error('Server Error!');
//     }
//     return await res.json();
// };

